// services/statisticsApi.js
import apiClient from '../../services/apiClient';

// Пільга тепер мультивибір. 'wo' і 'all' — не конкретні пільги, а спецрежими:
// 'wo'  — фільтр за пільгами вимкнено ("Всі заявки")
// 'all' — заявка має будь-яку пільгу ("Всі пільги")
// Якщо обрано конкретні пільги — передаємо їхні id через кому.
// (Припущення: бекенд queue_* приймає benefits=id1,id2 як список через кому —
// якщо це не так, тут достатньо змінити спосіб серіалізації.)
export const resolveBenefitsParam = (benefit) => {
  const arr = Array.isArray(benefit) ? benefit : (benefit ? [benefit] : ['wo']);
  if (arr.length === 0 || arr.includes('wo')) return 'wo';
  if (arr.includes('all')) return 'all';
  return arr.join(',');
};

// Загальний хелпер для мультивибору з ексклюзивним спецпунктом ('all' за
// замовчуванням — "без фільтра"). Якщо серед вибраних є цей спецпункт
// (або нічого не вибрано) — фільтр вимкнено. Інакше значення з'єднуються
// роздільником: кома скрізь, окрім спеціалізацій груп — там бекенд
// (kindergartens.getInfoAboutGroups) очікує крапку з комою.
export const resolveMultiParam = (values, { fallback = 'all', separator = ',' } = {}) => {
  const arr = Array.isArray(values) ? values : (values ? [values] : [fallback]);
  if (arr.length === 0 || arr.includes(fallback)) return fallback;
  return arr.join(separator);
};

export const statisticsApi = {
  // Заявки по районам
  getApplicationsByDistrict: (year, params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.kyiv_reg === 'kyiv_reg') queryParams.append('kyiv_reg', 'true');
    if (params.kyiv_mr === 'kyiv_mr_parent') queryParams.append('kyiv_mr_parent', 'true');
    if (params.with_move === 'with_move') queryParams.append('with_move', 'true');
    if (params.without_move === 'without_move') queryParams.append('without_move', 'true');
    if (params.benefits && params.benefits !== 'wo') queryParams.append('benefits', params.benefits);
    if (params.reserv && params.reserv !== 'all') queryParams.append('reserv', params.reserv);
    if (params.in_kg && params.in_kg !== 'all') queryParams.append('in_kg', params.in_kg);
    if (params.req_crt && params.req_crt !== 'all') queryParams.append('req_crt', params.req_crt);
    
    const url = `queue_distr/${year}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return apiClient.get(url);
  },

  // Общая статистика по заявкам (по Киеву)
  getTotalApplications: (year, params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.kyiv_reg === 'kyiv_reg') queryParams.append('kyiv_reg', 'true');
    if (params.kyiv_mr === 'kyiv_mr_parent') queryParams.append('kyiv_mr_parent', 'true');
    if (params.with_move === 'with_move') queryParams.append('with_move', 'true');
    if (params.without_move === 'without_move') queryParams.append('without_move', 'true');
    if (params.benefits && params.benefits !== 'wo') queryParams.append('benefits', params.benefits);
    if (params.reserv && params.reserv !== 'all') queryParams.append('reserv', params.reserv);
    if (params.in_kg && params.in_kg !== 'all') queryParams.append('in_kg', params.in_kg);
    if (params.req_crt && params.req_crt !== 'all') queryParams.append('req_crt', params.req_crt);
    
    const url = `queue_new_all/${year}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return apiClient.get(url);
  },

  // Заявки по садочкам
  getApplicationsByKindergarten: (year, params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.kyiv_reg === 'kyiv_reg') queryParams.append('kyiv_reg', 'true');
    if (params.kyiv_mr === 'kyiv_mr_parent') queryParams.append('kyiv_mr_parent', 'true');
    if (params.with_move === 'with_move') queryParams.append('with_move', 'true');
    if (params.without_move === 'without_move') queryParams.append('without_move', 'true');
    if (params.benefits && params.benefits !== 'wo') queryParams.append('benefits', params.benefits);
    if (params.reserv && params.reserv !== 'all') queryParams.append('reserv', params.reserv);
    if (params.in_kg && params.in_kg !== 'all') queryParams.append('in_kg', params.in_kg);
    if (params.req_crt && params.req_crt !== 'all') queryParams.append('req_crt', params.req_crt);
    
    const url = `queue_per_kg/${year}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return apiClient.get(url);
  },

  // Информация о группах
  getGroupsInfo: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.year) queryParams.append('year', params.year);
    if (params.distr && params.distr !== 'all') queryParams.append('distr', params.distr);
    if (params.age_type && params.age_type !== 'all') queryParams.append('age_type', params.age_type);
    if (params.place_type && params.place_type !== 'all') queryParams.append('place_type', params.place_type);
    if (params.spec && params.spec !== 'all') queryParams.append('spec', params.spec);
    if (params.disability_type && params.disability_type !== 'all') queryParams.append('disability_type', params.disability_type);
    if (params.international_agreement && params.international_agreement !== 'all') queryParams.append('international_agreement', params.international_agreement);
    if (params.benefits && params.benefits !== 'wo') queryParams.append('benefits', params.benefits);
    if (params.include_nf) queryParams.append('include_nf', 'true');
    if (params.only_nf) queryParams.append('age_type', '15');
    
    return apiClient.get(`kindergartens/getInfoAboutGroups?${queryParams.toString()}`);
  },

  // Получение годов и районов для фильтров
  getYearsAndDistricts: () => {
    return apiClient.get('kindergartens/getKGGroupsYears');
  },

  // Получение списка льгот
  getBenefits: () => {
    return apiClient.get('benefits');
  },

  // Отримання довідника типів труднощів (для мультивибору у фільтрі груп)
  getDisabilities: () => {
    return apiClient.get('disabilities');
  },

  // Детализация заявок по садочку
  getKindergartenDetail: (year, kgId, params = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.append('kg_id', kgId);
    if (params.kyiv_reg === 'kyiv_reg') queryParams.append('kyiv_reg', 'true');
    if (params.kyiv_mr === 'kyiv_mr_parent') queryParams.append('kyiv_mr_parent', 'true');
    if (params.with_move === 'with_move') queryParams.append('with_move', 'true');
    if (params.without_move === 'without_move') queryParams.append('without_move', 'true');
    if (params.benefits && params.benefits !== 'wo') queryParams.append('benefits', params.benefits);
    if (params.reserv && params.reserv !== 'all') queryParams.append('reserv', params.reserv);
    if (params.in_kg && params.in_kg !== 'all') queryParams.append('in_kg', params.in_kg);
    if (params.req_crt && params.req_crt !== 'all') queryParams.append('req_crt', params.req_crt);
    return apiClient.get(`queue_per_kg/${year}?${queryParams.toString()}`);
  },

  // Статистика по детям
  getChildrenStatistics: (data) => {
    return apiClient.post('statistics_childrens_general', data);
  },

  // Розподіл дітей за статтю / пільгою / типом труднощів. З kgId — для
  // одного садочка (лениве довантаження при розгортанні рядка); без kgId
  // (null/undefined) — той самий розріз по всьому місту одразу, для
  // зведеного графіка на вкладці "Діти в садочках".
  getChildrenDistributionByKindergarten: (kgId, data) => {
    const body = kgId ? { ...data, kg_id: kgId } : { ...data };
    return apiClient.post('statistics_childrens_by_kindergarten', body);
  }
};